import { batch, useDispatch } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import PropTypes from 'prop-types'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'
import { CampaignTypes, DashboardTypes } from 'features/Codes'
import { setType } from 'features/dashboard/dashboardCommonSlice'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import {
  exitEditable,
  keywordTableActions,
} from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import {
  addActives,
  addExpandCampaignType,
  setAdgroupId,
} from 'features/dashboard/tree/dashboardTreeSlice'
import { fetchDashboardInfoAdGroup } from 'features/dashboard/info/dashboardInfoSlice'

const AdGroupLink = ({
  id,
  campaignId,
  campaignType = CampaignTypes.PREMIUM_LINK,
  className = 'link_txt',
  tab = DashboardTypes.KEYWORD,
  children,
}) => {
  const dispatch = useDispatch()
  const { setSelectedIds: setAdGroupSelectedIds } = useDashboardTableActions(
    DashboardTypes.AD_GROUP
  )
  const { selectedIds: campaignIds } = useDashboardTableSelector(
    DashboardTypes.CAMPAIGN
  )
  const { setSelectedIds: setCampaignSelectedIds } = useDashboardTableActions(
    DashboardTypes.CAMPAIGN
  )
  const { editable } = useDashboardTableSelector(DashboardTypes.KEYWORD)

  return (
    <NoneAnchor
      className={className}
      onClick={() => {
        batch(() => {
          dispatch(setAdgroupId(id))
          dispatch(addExpandCampaignType(campaignType))
          dispatch(addActives(campaignId))
          dispatch(
            fetchDashboardInfoAdGroup({
              id,
              showError: true,
            })
          )
          dispatch(keywordTableActions.setPage(0))
          dispatch(creativeTableActions.setPage(0))
          dispatch(setAdGroupSelectedIds([id]))
          if (
            campaignId &&
            (campaignIds.length === 0 ||
              (campaignIds.length > 0 && !campaignIds.includes(campaignIds)))
          ) {
            dispatch(setCampaignSelectedIds([campaignId]))
          }
          dispatch(setType(tab))
          if (tab === DashboardTypes.KEYWORD && editable) {
            dispatch(exitEditable())
          }
        })
      }}>
      {children}
    </NoneAnchor>
  )
}
AdGroupLink.propTypes = {
  id: PropTypes.string.isRequired,
  campaignId: PropTypes.string,
  campaignType: PropTypes.oneOf([
    CampaignTypes.PREMIUM_LINK,
    CampaignTypes.TALK_CHANNEL,
  ]),
  className: PropTypes.string,
  tab: PropTypes.oneOf([DashboardTypes.KEYWORD, DashboardTypes.CREATIVE]),
  children: PropTypes.node,
}
export default AdGroupLink
